import { useCallback } from 'react';
import { EditOutlinedIcon } from 'tuui';
import { useNavigate } from 'hooks';
import { generateAccountFormPath } from 'modules/accounts/config/routes';
import ActionsCellRenderer from '../ActionsCellRenderer';

export const AccountListReportActionsCellRenderer = ({ data, ...rest }) => {
    const navigate = useNavigate();

    const handleEditClick = useCallback(() => {
        const accountName = data?.accountName;
        if (accountName) {
            const path = generateAccountFormPath(accountName);
            navigate(path);
        }
    }, [data, navigate]);

    const buttonConfigs = [
        {
            onClick: handleEditClick,
            isDisabled: false,
            icon: <EditOutlinedIcon />,
            iconLabel: 'edit',
            dataMetricComponent: 'EditAccountButton',
        },
    ];

    return <ActionsCellRenderer data={data} buttonConfigs={buttonConfigs} {...rest} />;
};
